module.exports = "/* * {\n    margin: 0;\n    padding: 0;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\nbody,\nhtml {\n    height: 100%;\n}\n\n#main {\n    max-width: 1280px;\n    min-height: 100%;\n    position: relative;\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main